import styled from 'styled-components'
import {Link} from 'react-router-dom'
import backNl from './../../theme/img/category-back-nl.png'

const backButton = {
  nl: backNl,
  fr: backNl,
  en: backNl,
}

export const Container = styled.div`
  position: absolute;
  top: 27.5%;
  left: 10%;
  right: 10%;
  width: 80%;
  columns: 2;
  column-gap: 4%;
`

export const Button = styled(Link)`
  float: left;
  width: 100%;
  transition: background-color 100ms;
  margin-bottom: 0.9vw;

  :hover {
    background-color: rgba(255, 255, 255, 0.2);
  }
`

export const Back = styled(Link)`
  background: transparent url('${props => backButton[props.locale]}') no-repeat center;
  background-size: cover;
  position: absolute;
  right: 10%;
  top: 10%;
  width: 32%;
  height: 0;
  padding-bottom: 3.44%;
  margin: 0;
`

export const Title = styled.h1`
  background: transparent url('${props => props.image}') no-repeat center;
  background-size: cover;
  position: absolute;
  left: 10%;
  top: 20%;
  width: 80%;
  height: 0;
  padding-bottom: 2.25%;
  margin: 0;
`
